import { useTheme } from "@mui/material";
import { useFeatureGate } from "@statsig/react-bindings";
import React from "react";

import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";
import { Status, StatusEnum } from "@/pages/scenario-builder/types"; // Adjust the import path as necessary

interface ScenarioStatusPillProps {
  status: StatusEnum;
}

const ScenarioStatusPill: React.FC<ScenarioStatusPillProps> = ({ status }) => {
  const theme = useTheme();
  const { value: isScenarioBuilderApprovalsEnabled } = useFeatureGate(
    featureFlag.scenarioBuilderApprovalsWorkflow
  );
  const style = Status.getStyle(status, theme);

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        minWidth: 140,
        borderRadius: "25px",
        border: `2px solid ${style.color}`,
        padding: "8.5px 14px",
      }}
    >
      <div
        style={{
          width: 15,
          height: 15,
          borderRadius: "50%",
          backgroundColor: style.color,
          marginRight: 8,
        }}
      />
      <Typography variant="body2" fontWeight={600}>
        {Status.toString(status, isScenarioBuilderApprovalsEnabled)}
      </Typography>
    </Stack>
  );
};

export default ScenarioStatusPill;
